import React, { useContext, useEffect } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";

import { useNavigate } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext.jsx";
import { updateApplication } from "../../Services/applicationService.jsx";
import Loader from "../Loader/Loader.jsx";

const PreLiveCheck = ({ handleNext }) => {
  const { appState, setAppState, userFlows } = useContext(AppContext);
  const [loading, setLoading] = React.useState(false);

  const navigate = useNavigate();
  const handlePartnerStore = () => {
    if (userFlows.isRenew) {
      const updatedAppState = {
      ...appState,
      requestPayload: {
        ...appState.requestPayload,
        photoShop: {
          flag: true,
        },
      },
    };
    setLoading(true);
    updateApplication(updatedAppState.requestPayload)
      .then(() => {
        setAppState(updatedAppState);
        setLoading(false);
        navigate("/app/application-at-store");
      })
      .catch(() => {
        setLoading(false);
      });
      return;
    }

    navigate("/app/photo-id");
  };

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const updatedPayload = {
          ...appState?.requestPayload,
          liveness: {
            livenessResult: false,
            livenessLink: "Liveness not completed",  // default value
            livenessStatusCode: 100000000,
          },
        };

        try {
          await updateApplication(updatedPayload);
        } catch (err) {
          console.error("Failed to update application with liveness", err);
        }

        if (cancelled) return;

        setAppState((prev) => ({
          ...prev,
          requestPayload: updatedPayload,
        }));
      } catch (err) {
        console.error("Failed to update application with liveness", err);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a form element
    const form = document.createElement("form");

    // Set method to GET and the action to your desired URL
    form.method = "POST";
    form.action =
      (process.env.REACT_APP_API_URL || "/api") + "/application/liveness";
    // Append the form to the body
    document.body.appendChild(form);

    // Submit the form to trigger a GET request and follow any redirects (302)
    form.submit();
  };

  return (
    <>
      {loading && <Loader />}
      <div className="intro" style={{ marginBottom: 64 }}>
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Whakatūturutia te pono o tāu e kī nei ko wai koe
        </h1>
        <hr />
        <h1 className="intro-title">Prove you are who you say you are</h1>

        <div className="step-container">
          <p className="mb-4">
            You're about to go to a different service to take a live photo. Once
            you've taken your photo, you'll return here to continue your
            application.
          </p>
          <p className="mb-4">
            We'll use this photo to check it matches other records we may have
            of you. We may also share it with an identity referee.
          </p>
          <p className="mb-4">
            For more information about how we'll use this photo, read our
            privacy statement.
          </p>

          <label className="terms-label">
            <ExternalLink
              href="https://www.realme.govt.nz/privacy/identity-verification-service-privacy-statement/"
              text="Privacy statement — Identity Verification Service"
            />
          </label>
        </div>
        <div className="step-button-container spacer-64">
          <SubmitButton text={"Continue"} onClick={handleSubmit} />
        </div>
        <div className="checkbox-wrapper mb-5">
          <label className="terms-label">
            <a href="#" className="cancel-link" onClick={handlePartnerStore}>
              I want to get my photo taken at a RealMe partner store
            </a>
          </label>
        </div>
      </div>
    </>
  );
};

export default PreLiveCheck;
